import {
  Academics,
  Admissions,
  CostAid,
  Overview,
  StudentLife,
  getProfileSectionsConfiguration,
} from '@scoir/college-details'

const { SECTIONS, INDEXES, INDEX_BY_ENDPOINT, LABELS } = getProfileSectionsConfiguration({
  0: {
    label: 'Overview',
    endpoint: 'overview',
    Component: Overview,
  },
  1: {
    label: 'Academics',
    endpoint: 'academics',
    Component: Academics,
  },
  2: {
    label: 'Admissions',
    endpoint: 'admissions',
    Component: Admissions,
  },
  3: {
    label: 'Cost & Aid',
    endpoint: 'cost-aid',
    Component: CostAid,
  },
  4: {
    label: 'Student Life',
    endpoint: 'student-life',
    Component: StudentLife,
  },
})

const sectionsConfiguration = {
  SECTIONS,
  INDEXES,
  INDEX_BY_ENDPOINT,
  LABELS,
}

export default sectionsConfiguration
